<template>
  <div class="relative home content" :class="[bgClass, bgClass? '' : 'mb-28']">
    <div class="px-3 pt-8 md:py-6 md:px-12">
      <div class="flex justify-between items-center -mt-7 w-full md:-mt-14 text-primary">
        <div
          class="hidden relative flex-col justify-between items-center -mt-48 space-x-4 bg-secondary md:block md:w-1/4">
          <div class="relative right-36 transform rotate-45 md:-top-10 lg:top-0 lg:right-0">
            <span class="absolute top-20 left-96 w-6 h-6 border-2 animate-ping border-gold"></span>
            <span class="absolute top-20 left-96 w-6 h-6 animate-pulse border-gold border-1"></span>
          </div>
        </div>
        <div class="flex flex-col items-center mt-32 mb-48 space-y-4 w-full md:w-1/2 md:space-y-8 md:mt-52">
          <div class="text-xl antialiased text-center animate-pulse md:text-3xl"><h3>Hi, i am</h3></div>
          <div class="flex flex-col justify-center items-center space-y-2 md:space-y-4 md:items-start">
            <div class="text-secondary">
              <h1
                class="text-3xl antialiased font-extrabold md:tracking-wide lg:tracking-tight md:text-5xl lg:text-7xl">
                Gabriel Ilochi</h1>
            </div>
            <div class="text-xl"><h3 class="text-sm text-justify md:text-2xl md:tracking-tight lg:tracking-tighter lg:text-4xl
            md:text-left">Tech enthusiast <i class="animate-bounce fas fa-smile-beam text-gold"></i> There are a lot of
              things to explore.</h3>
            </div>
          </div>
          <div
            class="flex justify-between items-center pt-3 space-x-5 text-sm text-black uppercase md:space-x-10 md:text-base">
            <router-link to="/contact#sectionC" exact-active-class="transform scale-110 text-active shadow-cst_md"
                         class="py-2 px-2 rounded ring-2 cursor-pointer bg-btn-primary md:rounded-lg ring-secondary hover:bg-secondary hover:text-primary hover:opacity-50">
              Contact Me
            </router-link>
            <router-link to="/projects#sectionP" exact-active-class="transform scale-110 text-active shadow-cst_md"
                         class="py-2 px-2 rounded ring-2 cursor-pointer bg-btn-secondary md:rounded-lg ring-gold hover:bg-secondary hover:text-gold hover:opacity-50">
              My Projects
            </router-link>
          </div>
        </div>
        <div class="flex hidden relative justify-between items-center -mt-48 bg-secondary md:block md:w-1/4">
          <div class="absolute right-14 flex-col justify-between items-center">
            <div class="relative transform rotate-45">
              <span class="absolute top-16 right-36 w-2 h-2 animate-ping border-gold border-1"></span>
              <span class="absolute top-16 right-36 w-2 h-2 animate-pulse border-gold border-1"></span>
            </div>
            <div
              class="absolute -right-11 top-52 rounded-full animate-bounce md:border-4 border-gold md:w-14 lg:w-20 md:h-14 lg:h-20"></div>
          </div>
          <div class="flex absolute right-0 -top-16 justify-end items-end transform rotate-90 bg-secondary">
            <div class="relative transform rotate-90">
              <span class="absolute h-10 border-1 border-secondary"></span>
            </div>
            <div class="relative transform rotate-90 bg-secondary">
              <span class="absolute bottom-2 h-6 border-1 border-secondary"></span></div>
            <div class="absolute"><span class="absolute left-14 -bottom-2.5 text-base tracking-loose select-none"> <a
              href="mailto:gabrielilochi@gmail.com?subject=Are You Open To A Role">gabrielilochi@gmail.com</a></span>
            </div>
            <div class="relative transform rotate-90">
              <span class="absolute bottom-64 h-6 border-1 border-secondary"></span>
            </div>
            <div class="relative transform rotate-90">
              <span class="absolute bottom-72 h-10 border-1 border-secondary"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  computed: {
    ...mapGetters(['bgClass'])
  }
}
</script>
<style>
.bgImage {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%), url('../assets/images/bg-photo.jpeg') no-repeat center;
  background-size: cover;
  width: 100%;
  height: 360px;
  background-clip: inherit;
  margin-bottom: 415px;
}

@media (max-width: 639px) {
  .bgImage {
    margin-bottom: 250px;
  }
}

.content {
  transition: ease-in-out background-color 1s;
}
</style>
